import { createConfig, http } from "wagmi";
import { injected } from "wagmi/connectors";
import { robinhood } from "./config";

export const wagmiConfig = createConfig({
  chains: [robinhood],
  connectors: [injected()],
  multiInjectedProviderDiscovery: true, // EIP-6963: every installed wallet shows up
  transports: { [robinhood.id]: http() },
});

declare module "wagmi" {
  interface Register {
    config: typeof wagmiConfig;
  }
}
